import React from 'react';
import useUser from 'src/hooks/useUser';
import { MenuType } from 'src/layouts/menuItems';

import {
  Backdrop,
  CircularProgress,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material';

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutIcon from '@mui/icons-material/Logout';

interface MenuProps {
  links: MenuType[];
  menuClickHandler: (link: string) => void;
}

export const MenuItems = ({
  links,
  menuClickHandler,
}: MenuProps): JSX.Element => {
  const { dbUser, fetchingUser } = useUser();

  if (fetchingUser) {
    return (
      <Backdrop open={fetchingUser}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  }

  return (
    <div>
      <MenuList>
        {links?.map((link, index) => (
          <MenuItem
            key={link.label}
            onClick={() => menuClickHandler(link.path)}
          >
            <ListItemIcon>{<link.icon fontSize='small' />}</ListItemIcon>
            <ListItemText>{link.label}</ListItemText>
          </MenuItem>
        ))}
        {dbUser?.isHokage && (
          <MenuItem key={'Hokage'} onClick={() => menuClickHandler('/hokage')}>
            <ListItemIcon>
              {<AdminPanelSettingsIcon fontSize='small' />}
            </ListItemIcon>
            <ListItemText>{'Hokage'}</ListItemText>
          </MenuItem>
        )}
        {dbUser && (
          <MenuItem key={'Logout'} onClick={() => menuClickHandler('/logout')}>
            <ListItemIcon>{<LogoutIcon fontSize='small' />}</ListItemIcon>
            <ListItemText>{'Logout'}</ListItemText>
          </MenuItem>
        )}
      </MenuList>
    </div>
  );
};
